import {
    IDynamicLinkedServiceTypeMetadata,
    ILinkedServiceTypeMetadata
} from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import {
    commonFileTypeStoreGetMetadataActivityReadSettings,
    commonFileTypeStoreDeleteActivityReadSettings,
    commonFileTypeStoreWriteSettingControls,
    commonBinaryStoreWriteSettingControls,
    getCommonFileTypeStoreReadSettingControls,
    getCommonBinaryStoreReadSettingControls,
    getAccessKeySecretUrl,
    getCommonDeltaStoreReadSettingControls,
    commonDeltaStoreWriteSettingControls,
    cdcDestination
} from '../consts/metadata-consts';
import { binaryMetadata } from '../dataset/binary-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { GlobalVariables } from 'app/services/globals';
import { deltaMetadata } from '../dataset/delta-metadata';

export const amazonS3CompatibleMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {

    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.amazonS3Compatible.linkedServiceType,
        displayName: stringResources.AmazonS3Compatible_DisplayText,
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'AmazonS3Compatible' as ResourceKind
        },
        linkedServiceKind: 'file',
        icon: {
            className: 'svg-i-100x100-AmazonS3'
        },
        isFirstClass: true,
        supportGetMetadataActivity: true,
        supportIncrementalBinaryCopy: true,
        supportDatasetV2: true,
        notSupportCopySink: !__IS_FABRIC_DPE__,
        locationPattern: {
            bucketName: '([^/]*)/?[^]*',
            folderPath: '[^/]*/([^]*)/[^/]*',
            fileName: '[^]*/([^/]*)'
        },
        containerLabel: stringResources.InputBucketPlaceHolder,
        containerLabelPlural: stringResources.InputBucketsPlaceHolder,
        locationPropertiesRequireParameters: ['bucketName', 'folderPath', 'fileName'],
        mergeReadSettingsInTrident: true,
        supportOPDG: GlobalVariables.enableOPDG,
        supportCopyJobSource: true,
        supportCopyJobSink: true,
        ...(GlobalVariables.copyJobGenericCdcPhase2 ? {
            cdc: {
                supportCDC: true,
                supportedCDCDestinations: cdcDestination,
                supportGenericCdc: true
            }
        } : {}),
        getMetadataActivityReadProperties: commonFileTypeStoreGetMetadataActivityReadSettings,
        supportFirstClassParameterExperience: true,
        deleteActivityReadProperties: commonFileTypeStoreDeleteActivityReadSettings,
        supportTestConnectionToFilePath: true,
        storeReadSettingControls: getCommonFileTypeStoreReadSettingControls(true),
        datasetTypeToStoreReadSettingControls: {
            [binaryMetadata.type]: getCommonBinaryStoreReadSettingControls(true),
            [deltaMetadata.type]: getCommonDeltaStoreReadSettingControls()
        },
        storeWriteSettingControls: [...commonFileTypeStoreWriteSettingControls],
        datasetTypeToStoreWriteSettingControls: {
            [binaryMetadata.type]: [...commonBinaryStoreWriteSettingControls],
            [deltaMetadata.type]: [...commonDeltaStoreWriteSettingControls]
        },
        category: ['File'],
        controls: [
            ...getAccessKeySecretUrl(stringResources.AmazonS3Compatible_DisplayText, false),
            {
                type: 'parameterizable',
                child: {
                    type: 'radio',
                    bind: 'forcePathStyle',
                    label: stringResources.forcePathStyle,
                    description: stringResources.forcePathStyleDesc,
                    isLabelVertical: true,
                    options: [
                        {
                            label: stringResources.Enable,
                            value: true
                        },
                        {
                            label: stringResources.Disable,
                            value: false
                        }
                    ],
                    defaultValue: false
                }
            }
        ],
        copySinkTypes: [],
        copySourceTypes: []
    };

    return metadata;
};
